import styled from 'styled-components';

export const Box = styled.div`
  display: grid;
  gap: 10px;
`;
